import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import ReactList from 'react-list'
import styled from 'styled-components'
import shortid from 'shortid'
import set from 'lodash/set'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import moment from '../../../../lib/moment.js'
import arrow_down from '../../../../static/images/arrow-down.svg'
import arrow_up from '../../../../static/images/arrow-up.svg'
import { selectStatusColor, selectStatusWord } from '../../../../function'
import { project_information_table_header } from '../../constants'
import { FONTS } from '../../../../constants'

export default class ProjectInfoTable extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'projects')) !== JSON.stringify(prevState.projects)) {
      const order = [
        'client',
        (item) => {
          if (!item.project_code) return null
          return item.project_code
        },
        'name',
        'project_type',
        'lob',
        'default_start_date',
        'default_end_date',
        'key_project_manager',
        'created',
        (item) => {
          const statusOrder = {
            'PRESALE': 1,
            'IMPLEMENTING': 2,
            'ACTIVE': 3,
            'DONE': 4,
            'INACTIVE': 5,
          }
          return statusOrder[item.status]
        },
      ]
      const list = orderBy(get(nextProps, 'projects'), order[prevState.sort_column], 'asc')
      set(tempState, 'projects', get(nextProps, 'projects'))
      set(tempState, 'items', [...list])
    }
    return tempState
  }

  state={
    sort_order: true,
    sort_column: 1,
    projects: [],
    items: [],
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(get(nextProps, 'projects')) === JSON.stringify(get(this.props, 'projects'))
    && JSON.stringify(get(nextState, 'items')) === JSON.stringify(get(this.state, 'items'))
    && nextState.sort_column === this.state.sort_column
    && nextState.sort_order === this.state.sort_order) return false
    return true
  }

  handleClickSort = (column) => {
    let { sort_order } = { ...this.state }
    const { projects } = this.state

    if (column === this.state.sort_column) {
      sort_order = !this.state.sort_order
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      sort_order = false
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
    sort_order = sort_order ? 'asc' : 'desc'
    const order = [
      'client',
      (item) => {
        if (!item.project_code) return null
        return item.project_code
      },
      'name',
      'project_type',
      'lob',
      'default_start_date',
      'default_end_date',
      'key_project_manager',
      'created',
      (item) => {
        const statusOrder = {
          'PRESALE': 1,
          'IMPLEMENTING': 2,
          'ACTIVE': 3,
          'DONE': 4,
          'INACTIVE': 5,
        }
        return statusOrder[item.status]
      },
    ]
    const list = orderBy(projects, order[column], sort_order)
    this.setState({ items: list })
  }

  renderItem = (index, key) => {
    const data = this.state.items[index]
    return (
      <tr
        key={ shortid() }
        style={ { cursor: 'pointer', hover: '#E5E5E5' } }
        onClick={ () => this.props.handleClickRow(true, data._id, key) }
      >
        <td>{ data.client }</td>
        <td>{ data.project_code }</td>
        <td>{ data.name }</td>
        <td>{ data.project_type }</td>
        <td>{ data.lob }</td>
        <td>{ data.start_date }</td>
        <td>{ data.end_date }</td>
        <td>{ data.key_project_manager === '' ? '-' : data.key_project_manager }</td>
        <td>{ moment(data.created).format('DD/MM/YYYY') }</td>
        <td style={ { color: selectStatusColor(data.status) } }>
          { selectStatusWord(data.status) }
        </td>
      </tr>
    )
  }

  render() {
    const { sort_order, sort_column, items } = this.state
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <CustomTable bordered hover>
          <Header>
            <tr>
              {
                project_information_table_header.map((h) =>
                  (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) } >
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up } alt="logo" />
                        :
                        <Icon src={ arrow_down } alt="logo" />
                    )
                    }</HeadTable>)
                )}
            </tr>
          </Header>
          <BodyTable style={ { overflowY: 'scroll' } }>
            <ReactList
              itemRenderer={ this.renderItem }
              length={ items.length }
            />
          </BodyTable>
        </CustomTable>
      </Wrapper>
    )
  }
}

ProjectInfoTable.propTypes = {
  handleClickRow: PropTypes.func.isRequired,
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const CustomTable = styled(Table)`
  background: white;
  thead {
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM_MEDIUM};
    font-size: ${FONTS.SMALL_SIZE};
    background-color: #404040;
  } tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border: none;
  } thead th {
    border: 1px solid #dee2e6;
    font-size: ${FONTS.SMALL_SIZE};
  } tbody td {
    border: 1px solid #dee2e6;
    font-size: ${FONTS.SMALL_SIZE};
    word-wrap: break-word;
  }
`
const BodyTable = styled.tbody`
  width: 100%;
  display: block;
  max-height: calc(100vh - 200px);
  overflow-y: scroll;
  // ::-webkit-scrollbar {
  //   display: none;
  // }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`
const Header = styled.thead`
  background: black;
  color: white;
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-project/index.js